function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "f0793c8d-2cc7-4dcf-96d3-b23677fc2573",
  x1: 459.23,
  y1: 847.99,
  x2: 459.23,
  y2: 385.75,
  gradientTransform: "translate(250.84)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "operating system");

var _ref4 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 629.72,
  cy: 780.56,
  rx: 122.56,
  ry: 26.18,
  fill: "#6c63ff",
  opacity: 0.1
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1120.55,730.47c-24.35,20.2-59,28.56-92.51,33.84l-5.64.86c-58.57,8.74-118.32,10.52-177.79,12.28-165.87,4.91-332.17,9.81-497.6-1.51-73.16-5-148.13-13.76-212.25-43.7l-1.67-.79c-.83-.39-1.66-.78-2.49-1.19A224.11,224.11,0,0,1,98,711.17c-18.31-13.06-33.43-29-41.42-47.91-12.52-29.66-5.9-63,8.4-92s35.8-55.12,54.34-82.43c5.44-8,10.6-16.3,15.4-24.81,30-53.37,44.88-115.13,13.43-166.56a228.58,228.58,0,0,0-13.43-19c-7.67-10-15.47-20-20.74-31.07-12.29-25.76-9.65-54.73-5.17-82.25,6-36.59,17.05-76,51.38-98.86,35.67-23.74,86.3-22.54,130.57-14,68.83,13.19,132.36,40.8,196.49,65.7S618.6,165.56,689.11,168c62.26,2.17,134.89-14,176.23-56.08,40.15-40.85,115.6-43.94,170-19.27,51.91,23.54,85.48,73.36,83,123.12-3.16,62.1-54.93,111.83-95.9,164.7-6.81,8.79-13.33,17.68-19.28,26.72-19.42,29.53-33.15,65-19.78,96.88,7.5,17.85,21.81,31.47,39.06,43.36,38.65,26.63,92,44.55,116,81.83C1159.11,661.42,1151.45,704.82,1120.55,730.47Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff",
  opacity: 0.1
});

var _ref6 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 972.5,
  cy: 704.85,
  rx: 57.01,
  ry: 10.96,
  fill: "#6c63ff"
});

var _ref7 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 971.55,
  cy: 700.19,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref8 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 971.55,
  cy: 689.57,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref9 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 971.55,
  cy: 678.94,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref10 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 971.55,
  cy: 668.32,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref11 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 971.55,
  cy: 657.7,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref12 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 971.55,
  cy: 647.08,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref13 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 971.55,
  cy: 636.46,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1046.4,610.41a31,31,0,0,0,2.47-3.64l-17.44-2.86,18.86.14a31.78,31.78,0,0,0,.61-25.2L1025.59,592l23.34-17.15a31.8,31.8,0,1,0-52.51,35.58,31.55,31.55,0,0,0-3.63,5.8L1015.43,628l-24.14-8.1a31.79,31.79,0,0,0,5.13,29.86,31.8,31.8,0,1,0,50,0,31.78,31.78,0,0,0,0-39.32Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M989.61,630.07a31.68,31.68,0,0,0,6.81,19.66,31.8,31.8,0,1,0,50,0C1050.66,644.32,989.61,626.5,989.61,630.07Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M184.73,720.54c0,5.59-21.81,10.21-50,10.87l-1.67,0c-.83-.39-1.66-.78-2.49-1.19A224.11,224.11,0,0,1,98,711.17c6.85-.8,14.64-1.34,23-1.52l1.13,0c1.82,0,3.67-.06,5.54-.06,1.22,0,2.43,0,3.62,0l1.18,0c.76,0,1.51,0,2.25,0C162.92,710.32,184.73,715,184.73,720.54Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref17 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 76.76,
  cy: 669.25,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref18 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 76.76,
  cy: 658.63,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref19 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 76.76,
  cy: 648.01,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref20 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 76.76,
  cy: 637.39,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref21 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 76.76,
  cy: 626.77,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref22 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 76.76,
  cy: 616.15,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref23 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 76.76,
  cy: 605.52,
  rx: 6.64,
  ry: 8.69,
  fill: "#3f3d56"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M151.61,579.47a32.28,32.28,0,0,0,2.48-3.63L136.64,573l18.87.14a31.8,31.8,0,0,0,.6-25.19l-25.3,13.13,23.34-17.16a31.8,31.8,0,1,0-52.52,35.58,32.45,32.45,0,0,0-3.63,5.8L120.64,597,96.5,588.93a31.87,31.87,0,0,0,5.13,29.86,31.8,31.8,0,1,0,50,0,31.78,31.78,0,0,0,0-39.32Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.83,599.13a31.67,31.67,0,0,0,6.8,19.66,31.8,31.8,0,1,0,50,0C155.87,613.38,94.83,595.56,94.83,599.13Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref26 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M355.84,601.92c0,.94-.1,1.86-.2,2.76Q344,600,332.72,594.75a18.59,18.59,0,0,1-10.6-5.17c-2.19-1.1-4.37-2.24-6.54-3.39a26.82,26.82,0,0,1,1.66-3c4.2-6.66,10.6-10.83,17.65-10.6s13.15,4.78,16.93,11.66A34.37,34.37,0,0,1,355.84,601.92Z",
  transform: "translate(-50 -46.63)",
  fill: "#3f3d56"
}), React.createElement("path", {
  d: "M357,567a34.56,34.56,0,0,1-5.13,17.32c-4.21,6.64-10.6,10.81-17.65,10.58-.49,0-1-.06-1.45-.1a18.59,18.59,0,0,1-10.6-5.17,25.27,25.27,0,0,1-4.88-6.37,35.82,35.82,0,0,1,1.1-35c4.21-6.66,10.6-10.83,17.65-10.6s13.15,4.78,16.93,11.66A34.47,34.47,0,0,1,357,567Z",
  transform: "translate(-50 -46.63)",
  fill: "#3f3d56"
}), React.createElement("ellipse", {
  cx: 336.18,
  cy: 531.28,
  rx: 28.63,
  ry: 21.87,
  transform: "translate(-255.43 803.92) rotate(-88.19)",
  fill: "#3f3d56"
}), React.createElement("ellipse", {
  cx: 337.29,
  cy: 496.31,
  rx: 28.63,
  ry: 21.87,
  transform: "translate(-219.41 771.16) rotate(-88.19)",
  fill: "#3f3d56"
}), React.createElement("ellipse", {
  cx: 338.39,
  cy: 461.34,
  rx: 28.63,
  ry: 21.87,
  transform: "translate(-183.39 738.39) rotate(-88.19)",
  fill: "#3f3d56"
}), React.createElement("path", {
  d: "M264.12,219.46a105.78,105.78,0,0,1-7.76-12.24l57.72-7.62L252,198.1a104.92,104.92,0,0,1,.62-83l82,45.85L259.47,102A104.75,104.75,0,1,1,428.69,224.65,105.13,105.13,0,0,1,440,244.11l-75.77,36.38,80.33-24.17a104.85,104.85,0,0,1-20,97.78A104.75,104.75,0,1,1,260,348.91a104.73,104.73,0,0,1,4.08-129.45Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
}), React.createElement("path", {
  d: "M449.05,290.08a104.29,104.29,0,0,1-24.44,64A104.75,104.75,0,1,1,260,348.91C246.57,330.66,449.42,278.33,449.05,290.08Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
}));

var _ref27 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M848.18,527.14c0,.67-.07,1.32-.14,2q-8.31-3.29-16.31-7.06a13.31,13.31,0,0,1-7.55-3.68c-1.55-.79-3.11-1.6-4.65-2.41a19.78,19.78,0,0,1,1.18-2.13c3-4.74,7.54-7.7,12.56-7.54s9.36,3.4,12.05,8.3A24.5,24.5,0,0,1,848.18,527.14Z",
  transform: "translate(-50 -46.63)",
  fill: "#3f3d56"
}), React.createElement("path", {
  d: "M849,502.25a24.56,24.56,0,0,1-3.65,12.33c-3,4.72-7.54,7.69-12.56,7.53l-1-.07a13.31,13.31,0,0,1-7.55-3.68,18.32,18.32,0,0,1-3.47-4.54,25.51,25.51,0,0,1,.78-24.88c3-4.74,7.55-7.71,12.56-7.55s9.37,3.4,12.05,8.3A24.55,24.55,0,0,1,849,502.25Z",
  transform: "translate(-50 -46.63)",
  fill: "#3f3d56"
}), React.createElement("ellipse", {
  cx: 834.19,
  cy: 476.87,
  rx: 20.37,
  ry: 15.56,
  transform: "translate(281.27 1248.98) rotate(-88.19)",
  fill: "#3f3d56"
}), React.createElement("ellipse", {
  cx: 834.98,
  cy: 451.98,
  rx: 20.37,
  ry: 15.56,
  transform: "translate(306.9 1225.67) rotate(-88.19)",
  fill: "#3f3d56"
}), React.createElement("ellipse", {
  cx: 835.76,
  cy: 427.1,
  rx: 20.37,
  ry: 15.56,
  transform: "translate(332.53 1202.35) rotate(-88.19)",
  fill: "#3f3d56"
}), React.createElement("path", {
  d: "M782.91,255a73.57,73.57,0,0,1-5.52-8.71l41.08-5.42-44.21-1.07a74.67,74.67,0,0,1,.43-59.07L833,213.32,779.6,171.39A74.55,74.55,0,1,1,900,258.65a74.71,74.71,0,0,1,8.06,13.86L854.17,298.4l57.17-17.2a74.55,74.55,0,0,1-14.22,69.58A74.54,74.54,0,1,1,780,347.09,74.55,74.55,0,0,1,782.91,255Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
}), React.createElement("path", {
  d: "M914.52,305.22a74.2,74.2,0,0,1-17.4,45.56A74.54,74.54,0,1,1,780,347.09C770.42,334.09,914.78,296.86,914.52,305.22Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
}));

var _ref28 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M635,449.09c0,.67-.08,1.32-.15,2q-8.31-3.29-16.31-7.06a13.28,13.28,0,0,1-7.54-3.68c-1.56-.79-3.11-1.6-4.65-2.41a19,19,0,0,1,1.17-2.13c3-4.73,7.55-7.7,12.56-7.54s9.36,3.4,12.05,8.3A24.5,24.5,0,0,1,635,449.09Z",
  transform: "translate(-50 -46.63)",
  fill: "#3f3d56"
}), React.createElement("path", {
  d: "M635.74,424.2a24.56,24.56,0,0,1-3.65,12.33c-3,4.72-7.54,7.69-12.56,7.53-.35,0-.68,0-1-.07a13.28,13.28,0,0,1-7.54-3.68,18.11,18.11,0,0,1-3.48-4.54,25.48,25.48,0,0,1,.79-24.88c3-4.74,7.54-7.71,12.56-7.55s9.36,3.4,12,8.3A24.54,24.54,0,0,1,635.74,424.2Z",
  transform: "translate(-50 -46.63)",
  fill: "#3f3d56"
}), React.createElement("ellipse", {
  cx: 620.97,
  cy: 398.82,
  rx: 20.37,
  ry: 15.56,
  transform: "matrix(0.03, -1, 1, 0.03, 152.77, 960.28)",
  fill: "#3f3d56"
}), React.createElement("ellipse", {
  cx: 621.75,
  cy: 373.93,
  rx: 20.37,
  ry: 15.56,
  transform: "translate(178.4 936.96) rotate(-88.19)",
  fill: "#3f3d56"
}), React.createElement("ellipse", {
  cx: 622.54,
  cy: 349.05,
  rx: 20.37,
  ry: 15.56,
  transform: "translate(204.04 913.64) rotate(-88.19)",
  fill: "#3f3d56"
}), React.createElement("path", {
  d: "M569.68,176.91a74.87,74.87,0,0,1-5.52-8.71l41.08-5.42L561,161.71a74.62,74.62,0,0,1,.44-59.07l58.33,32.63L566.38,93.34A74.54,74.54,0,1,1,686.8,180.6a74.76,74.76,0,0,1,8.07,13.86L641,220.35l57.16-17.2a74.55,74.55,0,0,1-14.22,69.58A74.54,74.54,0,1,1,566.78,269a74.57,74.57,0,0,1,2.9-92.13Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
}), React.createElement("path", {
  d: "M701.29,227.17a74.2,74.2,0,0,1-17.4,45.56A74.54,74.54,0,1,1,566.78,269C557.19,256.05,701.55,218.81,701.29,227.17Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
}));

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1022.4,547.44V765.17c-58.57,8.74-118.32,10.52-177.79,12.28-165.87,4.91-332.17,9.81-497.6-1.51-73.16-5-148.13-13.76-212.25-43.7V464c.24-185-.76,0,0-185.56V211.85a14.1,14.1,0,0,1,14.1-14.1H1008.3a14.1,14.1,0,0,1,14.1,14.1V380.48C1023,547,1022,381,1022.4,547.44Z",
  transform: "translate(-50 -46.63)",
  fill: "#3f3d56"
});

var _ref30 =
/*#__PURE__*/
React.createElement("rect", {
  x: 344.15,
  y: 217.75,
  width: 368.86,
  height: 28.56,
  rx: 5.22,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M737.94,279.85h-.61l-.23-.19a5.1,5.1,0,0,0,1.19-3.25,4.94,4.94,0,1,0-4.92,5,5.09,5.09,0,0,0,3.24-1.18l.22.19V281l3.81,3.82,1.14-1.14Zm-4.57,0a3.44,3.44,0,1,1,3.43-3.44A3.42,3.42,0,0,1,733.37,279.85Z",
  transform: "translate(-50 -46.63)",
  fill: "#444053"
});

var _ref32 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.84,
  y: 493.2,
  width: 34.42,
  height: 11.9,
  rx: 5,
  fill: "#3f3d56",
  opacity: 0.7
});

var _ref33 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.84,
  y: 522.95,
  width: 53.54,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref34 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.84,
  y: 508.08,
  width: 107.09,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M214.57,569.21a5.74,5.74,0,0,0-5.8,5.69,3.88,3.88,0,0,1-3.87,3.79,10,10,0,0,0,7.73,3.8,7.67,7.67,0,0,0,7.75-7.59A5.75,5.75,0,0,0,214.57,569.21Zm26.53-17.76-2.6-2.55a1.94,1.94,0,0,0-2.72,0l-17.34,17,5.32,5.22,17.32-17A1.86,1.86,0,0,0,241.1,551.45Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref36 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.84,
  y: 345.66,
  width: 34.42,
  height: 11.9,
  rx: 5,
  fill: "#3f3d56",
  opacity: 0.7
});

var _ref37 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.84,
  y: 375.41,
  width: 53.54,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref38 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.84,
  y: 360.53,
  width: 107.09,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M241.18,424.78,226,409.5a10.82,10.82,0,0,0-2.51-11.58,11,11,0,0,0-12.35-2.18l7.18,7.22-5,5L206,400.78a10.86,10.86,0,0,0,2.17,12.41,10.66,10.66,0,0,0,11.51,2.52L234.83,431a1.61,1.61,0,0,0,2.34,0l3.84-3.86a1.51,1.51,0,0,0,.17-2.35Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref40 =
/*#__PURE__*/
React.createElement("rect", {
  x: 509.6,
  y: 493.2,
  width: 34.42,
  height: 11.9,
  rx: 5,
  fill: "#3f3d56",
  opacity: 0.7
});

var _ref41 =
/*#__PURE__*/
React.createElement("rect", {
  x: 509.6,
  y: 522.95,
  width: 53.54,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref42 =
/*#__PURE__*/
React.createElement("rect", {
  x: 509.6,
  y: 508.08,
  width: 107.09,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M509.44,572.63a10,10,0,0,1-9.89,0c-3.87,1.19-6.24,5.09-7.12,8.54h24.12C515.68,577.72,513.32,573.82,509.44,572.63Zm-4.94-18.37a8.69,8.69,0,1,0,8.69,8.68A8.69,8.69,0,0,0,504.5,554.26Zm0,15.3a6.71,6.71,0,0,1-6.07-4.14h12.14A6.71,6.71,0,0,1,504.5,569.56Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M522.09,568a10.07,10.07,0,0,1-8.4.69,12,12,0,0,1-2.3,2.86,11.24,11.24,0,0,1,4.9,4.33H529.2A10.72,10.72,0,0,0,522.09,568Zm-4.94-18.38a8.71,8.71,0,0,0-7.33,4,10.78,10.78,0,0,1,5.15,7.14h8.25a6.72,6.72,0,0,1-6.07,4.12,6,6,0,0,1-2.08-.38,11.65,11.65,0,0,1-.54,2.07,8.35,8.35,0,0,0,2.62.4,8.69,8.69,0,0,0,0-17.38Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref45 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.84,
  y: 603.86,
  width: 34.42,
  height: 11.9,
  rx: 5,
  fill: "#3f3d56",
  opacity: 0.7
});

var _ref46 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.84,
  y: 633.61,
  width: 53.54,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref47 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.84,
  y: 618.74,
  width: 107.09,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M226.57,654.25h-9.82a3.28,3.28,0,0,0-3.32,3.24v.7h-.62a3.28,3.28,0,0,0-3.32,3.24v23.63a3.34,3.34,0,0,0,3.32,3.32h17.08a3.27,3.27,0,0,0,3.23-3.32v-.62h.71a3.27,3.27,0,0,0,3.23-3.32V664.75Zm0,3.66,6.84,6.84h-6.84Zm3.94,27.15a.67.67,0,0,1-.62.7H212.81a.73.73,0,0,1-.69-.7V661.43a.67.67,0,0,1,.69-.62h.62v21c0,1.82.86,2.66,2.67,2.66h14.41Zm3.93-3.94a.66.66,0,0,1-.61.7H216.75a.73.73,0,0,1-.69-.7V657.49a.67.67,0,0,1,.69-.62h7.19v10.51h10.5Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref49 =
/*#__PURE__*/
React.createElement("rect", {
  x: 509.6,
  y: 345.66,
  width: 34.42,
  height: 11.9,
  rx: 5,
  fill: "#3f3d56",
  opacity: 0.7
});

var _ref50 =
/*#__PURE__*/
React.createElement("rect", {
  x: 509.6,
  y: 375.41,
  width: 53.54,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref51 =
/*#__PURE__*/
React.createElement("rect", {
  x: 509.6,
  y: 360.53,
  width: 107.09,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M507.32,400H495.94a3.51,3.51,0,0,0-3.5,3.51v19.25a3.5,3.5,0,0,0,3.5,3.5H525.7a3.5,3.5,0,0,0,3.5-3.5V407.42a3.51,3.51,0,0,0-3.5-3.5H510.82l-3.5-3.94Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref53 =
/*#__PURE__*/
React.createElement("rect", {
  x: 792.79,
  y: 493.2,
  width: 34.42,
  height: 11.9,
  rx: 5,
  fill: "#3f3d56",
  opacity: 0.7
});

var _ref54 =
/*#__PURE__*/
React.createElement("rect", {
  x: 792.79,
  y: 522.95,
  width: 53.54,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref55 =
/*#__PURE__*/
React.createElement("rect", {
  x: 792.79,
  y: 508.08,
  width: 107.09,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M812.93,555.91l-6.77-.32-.4-4.41a1.7,1.7,0,0,0-1.88-1.52l-24.27,2a1.67,1.67,0,0,0-1.59,1.79l1.73,19.35a1.7,1.7,0,0,0,1.88,1.49l1.23-.09-.19,3.76a1.87,1.87,0,0,0,1.83,1.93l27.09,1.28a1.88,1.88,0,0,0,2-1.74l1.14-21.6A1.86,1.86,0,0,0,812.93,555.91Zm-29.12.44-.58,11.06-1.44,2-1.32-14.61v-.09a.89.89,0,0,1,.78-.77l21.42-1.75a.81.81,0,0,1,.87.64s0,0,0,0,0,0,0,0l.21,2.52-18-.86A1.9,1.9,0,0,0,783.81,556.35Zm27.4,19.44-7-8.17-3.07,2.82-5.67-6.63-10.07,10.72.86-16.33v0a.94.94,0,0,1,1-.74l23.9,1.16a.87.87,0,0,1,.85.83s0,0,0,0Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M806.89,565.42a2.63,2.63,0,1,0-2.62-2.63A2.64,2.64,0,0,0,806.89,565.42Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref58 =
/*#__PURE__*/
React.createElement("rect", {
  x: 795.17,
  y: 345.66,
  width: 34.42,
  height: 11.9,
  rx: 5,
  fill: "#3f3d56",
  opacity: 0.7
});

var _ref59 =
/*#__PURE__*/
React.createElement("rect", {
  x: 795.17,
  y: 375.41,
  width: 53.54,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref60 =
/*#__PURE__*/
React.createElement("rect", {
  x: 795.17,
  y: 360.53,
  width: 107.09,
  height: 11.9,
  rx: 5,
  fill: "#6c63ff",
  opacity: 0.3
});

var _ref61 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 762.56,
  cy: 356.63,
  r: 5.25,
  fill: "#6c63ff"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M808.53,409.45l-10.42,6.94-14.44-9.62v-3.51l14.44,9.63,8.3-5.53a7.39,7.39,0,0,1-.1-8H783.24a3.52,3.52,0,0,0-3.51,3.51v21.88a3.52,3.52,0,0,0,3.51,3.51H813a3.51,3.51,0,0,0,3.5-3.51v-15.2a7.37,7.37,0,0,1-8-.06Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref63 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 509.64,
  cy: 746.02,
  rx: 26.08,
  ry: 5.01,
  fill: "#6c63ff"
});

var _ref64 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 509.21,
  cy: 743.89,
  rx: 3.04,
  ry: 3.97,
  fill: "#3f3d56"
});

var _ref65 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 509.21,
  cy: 739.03,
  rx: 3.04,
  ry: 3.97,
  fill: "#3f3d56"
});

var _ref66 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 509.21,
  cy: 734.17,
  rx: 3.04,
  ry: 3.97,
  fill: "#3f3d56"
});

var _ref67 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 509.21,
  cy: 729.31,
  rx: 3.04,
  ry: 3.97,
  fill: "#3f3d56"
});

var _ref68 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 509.21,
  cy: 724.46,
  rx: 3.04,
  ry: 3.97,
  fill: "#3f3d56"
});

var _ref69 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 509.21,
  cy: 719.6,
  rx: 3.04,
  ry: 3.97,
  fill: "#3f3d56"
});

var _ref70 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 509.21,
  cy: 714.74,
  rx: 3.04,
  ry: 3.97,
  fill: "#3f3d56"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M570.57,728.13a13.59,13.59,0,0,0,1.13-1.67l-8-1.31,8.62.07a14.59,14.59,0,0,0,.28-11.52l-11.57,6,10.67-7.85a14.54,14.54,0,1,0-24,16.28,15.11,15.11,0,0,0-1.66,2.65l10.36,5.38-11-3.7a14.53,14.53,0,0,0,2.34,13.65,14.54,14.54,0,1,0,22.86,0,14.55,14.55,0,0,0,0-18Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M544.6,737.12a14.45,14.45,0,0,0,3.11,9,14.54,14.54,0,1,0,22.86,0C572.52,743.64,544.6,735.49,544.6,737.12Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  d: "M802,436.86a13.68,13.68,0,0,1-1-2.7c-.1-1.07.32-2.48-.63-3-.53-.29-1.27-.07-1.74-.45a2.15,2.15,0,0,1-.51-1.2,4.1,4.1,0,0,0-3.8-3c1-2.71,4.68-3.37,6.3-5.76.81-1.19.55-3.38-.88-3.39a2.49,2.49,0,0,0-1,.25l-5.33,2.2a27.35,27.35,0,0,0-3,1.39c-2.93,1.67-5.12,4.38-7.09,7.13a30.49,30.49,0,0,0-4.41,8,18,18,0,0,0-.94,5.49c0,.19,0,.38,0,.56-.87.15-1.58.53-2.49.71l-2.07,5.47a6.93,6.93,0,0,1-1.35,2.49,12.52,12.52,0,0,1-1.46,1.15,8.45,8.45,0,0,0-2.91,7.37,7.93,7.93,0,0,0-4.66,9.78,9.31,9.31,0,0,0-6.81,6,4.43,4.43,0,0,1-.89,1.88,3.55,3.55,0,0,1-2.37.73c-2.34.15-4.38,2-6.49,1a13.21,13.21,0,0,0-7.71-1.08,5.77,5.77,0,0,1-1.65.15,4.43,4.43,0,0,1-1.35-.47,10.46,10.46,0,0,0-3.06-1.21,2.84,2.84,0,0,0-2.9,1.12c-.74-.81-1.18-1.86-1.85-2.73a3,3,0,0,0-2.82-1.35c.7-.63,0-1.89-.93-2.11a11.56,11.56,0,0,0-2.81.1c-2.44,0-4.32-2.24-6.69-2.83-2.18-.53-5.09.11-6.21-1.85-.35-.63-.45-1.45-1-1.92a3.64,3.64,0,0,0-.71-1.45c-.9-1-2.41-1.16-3.76-1.12a15.68,15.68,0,0,0-4.37.75c0-.17-.09-.36-.15-.56a11.09,11.09,0,0,0-4.84-5.94A20,20,0,0,0,688,454.2c0-.18,0-.35,0-.53a22.55,22.55,0,0,1,1.16-7.43c.08-.26.18-.52.27-.78a26.6,26.6,0,0,0,12-44.63,6.83,6.83,0,0,0-.21-1.6,7.86,7.86,0,0,0-1.6-3.12c-1.22-2.72-3.12-3.92-5.55-5.06-.7-.33-1.44-.65-2.22-1-3.87-1.74-7.61-4.3-12-4.29-4,0-7.86,2.21-11.82,2.13l-.3,0h-.29l-.36,0c-1.11-.13-2.44-.39-3.17.46a4.5,4.5,0,0,0-.56,1.09,2.64,2.64,0,0,1-.2.37h0a4.4,4.4,0,0,1-.51.69h0c-1.28,1.4-3.43,2-5.2,2.94-4,2.05-6.62,6.23-7.66,10.61s-.68,9,.1,13.44c.4,2.22,1.26,4.74,2.84,6.14h0l0,0s-13.37,9.51-10.93,10.86c1.33.74,6.87-2.77,11.64-6.12.05.2.09.41.15.61a44,44,0,0,0,2.18,6.25c1,2.39,2.44,5,4.93,5.69a5.36,5.36,0,0,0,1.69.19l.44,0a39.39,39.39,0,0,1-1.15,10.87,6.61,6.61,0,0,0-4.09,1.13,3.29,3.29,0,0,1-1.66.88,2.89,2.89,0,0,1-1.71-.84,9.7,9.7,0,0,0-12.14.64c-4.84,4.57-4.29,13.49-10,16.95-1.56.95-3.56,1.46-4.48,3.05a11.41,11.41,0,0,1-.77,1.47,4.05,4.05,0,0,1-1.36,1,26.48,26.48,0,0,0-4.68,2.7,6.72,6.72,0,0,0-2.69,4.54,8.61,8.61,0,0,0,.82,3.81,36.44,36.44,0,0,0,3.12,6,6.38,6.38,0,0,0-1.26,2.95c-.4,2.81.94,5.58,1.09,8.42.13,2.48-.66,4.9-1.1,7.34-1.76,9.54,1.61,19.2,5,28.26a14.58,14.58,0,0,1,1.2,4.65c.09,3-1.6,5.67-2.07,8.59-1,6.14,3.53,11.92,3.63,18.13,0,2.87-.86,5.78-.14,8.55.47,1.85,1.62,3.44,2.44,5.17,1.44,3.06,1.83,6.53,3.21,9.62a23.07,23.07,0,0,0,7.12,8.48c1.73,5.49-.73,12.12,0,18q1.41-.56,2.85-1a41.17,41.17,0,0,0,6.3,24.84c1.55,2.42,3.37,4.68,4.54,7.31a34.26,34.26,0,0,1,1.77,5.79q2.51,10.47,5,20.92c1.36,5.65,2.73,11.4,2.32,17.2-.28,4-1.3,8.57,1.18,11.77a8.51,8.51,0,0,1,1.49,2.06,5.22,5.22,0,0,1,0,2.72,180.71,180.71,0,0,0-2.48,20.39c-.56.75-1.12,1.51-1.63,2.26-4.11,6-6.09,13.21-7.69,20.32a245.83,245.83,0,0,0-5.16,42.44,28.38,28.38,0,0,0-5.26,6.41c-2.15,4-2.43,8.7-2.66,13.24a4.73,4.73,0,0,0,.24,2.18A4.48,4.48,0,0,0,644.2,822l1.24.59c-.27,1-.51,2-.72,3.05-1.58-1.78-4.39-4.6-4.87-2.54a101.78,101.78,0,0,0-2.56,21,1.77,1.77,0,0,0,1.9,2.12A116.25,116.25,0,0,0,660,848c5.65,0,11.29-.46,16.92-.89l5.77-.44a127.7,127.7,0,0,0,17.67-2.19c2.55-.56,5.18-1.35,7.1-3.14s2.86-4.85,1.54-7.12v0c-1.61-2.74-5.37-2.94-8.51-3.38a27.85,27.85,0,0,1-8.92-2.84c-.63-.32-1.24-.68-1.85-1,.16,0,.33-.08.48-.14,2.7-.91,4.85-3,7.39-4.25,3-1.45,6.31-1.78,9.57-2.19s6.62-1,9.33-2.86c2.54-1.74,4.34-4.91,3.75-7.89a5.15,5.15,0,0,0-.16-.62c-1-3.23-4.5-5-7.76-5.8s-6.8-1.28-9.44-3.38l-.39-.31c-.22-.19-.45-.37-.69-.56a5.62,5.62,0,0,0,.77-3.26c-.14-1.79-1.18-3.37-1.89-5-1.39-3.25-1.5-6.88-1.88-10.39-.94-8.83-3.65-17.35-5.69-26-.23-1-.45-2-.67-3a62.86,62.86,0,0,1,7.27-11.64,38,38,0,0,0,7-13.77c.42-1.54.73-3.1,1.05-4.67Q713.18,694.18,718,667a45.19,45.19,0,0,0,.91-7.84,23.89,23.89,0,0,0,1.35-7.43c.94-3.67,1.89-7.52,1.12-9.92-.54-1.7-.81-7.51-1.11-13.08a50.24,50.24,0,0,0-.54-8.93c-.09-.51-.19-1-.3-1.51q-.09-.45-.18-.75a25.68,25.68,0,0,0-1.76-4.86,23.63,23.63,0,0,0-1.32-2.71,12.34,12.34,0,0,0-1-1.48,62,62,0,0,1,6.22.58c.5.07,1.12.11,1.43-.3A1.47,1.47,0,0,0,723,608a12.75,12.75,0,0,0-1.62-6.76c-.8-1.42-1.91-2.8-1.88-4.43a6.53,6.53,0,0,1,.55-2.2l2.77-7.44c2.35-6.29,1.23-13.58,2.45-20.18a118.46,118.46,0,0,0,1.82-15.61c.23-4.47.09-9.32-2.6-12.9a14.73,14.73,0,0,1-2-2.84,8.41,8.41,0,0,1-.48-3.39q-.07-10.51.42-21a206.38,206.38,0,0,0,35.05-4,22,22,0,0,0,4-1.08,20.19,20.19,0,0,0,4-2.53c3.93-2.84,7.92-5.73,10.91-9.55a32.36,32.36,0,0,0,6.46-15.94c2.84-2.63,4.35-6.37,5.77-10a15.42,15.42,0,0,0,1.32-4.85c.07-1.72-1.06-3.52-.74-5.21a13.78,13.78,0,0,1,4.19-7.58,2.74,2.74,0,0,0,1-1.33,2.12,2.12,0,0,0-.23-1.3l-.09-.15c.28-.17.54-.35.81-.53.93-.66,1.82-1.39,2.69-2.1a17,17,0,0,0,3.49-3.54A5.75,5.75,0,0,0,802,436.86ZM673.69,820.15c-.24,0-.48,0-.71.06a9.57,9.57,0,0,0-2.54.73l-.19.1c1.1-2.38,2.14-4.8,3.08-7.26.11-.29.21-.58.32-.88l-.12,1.64A20.22,20.22,0,0,0,673.69,820.15Z",
  transform: "translate(-50 -46.63)",
  fill: "url(#f0793c8d-2cc7-4dcf-96d3-b23677fc2573)"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M688,455.73c.1,3.88,1.42,7.64,1.62,11.52-11.43.57-22.72-5-34-3.28,3.17-2.05,4.86-5.74,5.86-9.37a38.9,38.9,0,0,0,1.11-14.41,6.61,6.61,0,0,0-.14-.79c-.42-1.9-1.51-4.59-1.22-6.08.39-2,2.25-1.59,3.93-1.48a150.51,150.51,0,0,1,15.26,2c1.32.23,14.13,3.43,14.33,3.1a59.69,59.69,0,0,0-5.55,11.43A22.32,22.32,0,0,0,688,455.73Z",
  transform: "translate(-50 -46.63)",
  fill: "#ee8e9e"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M801.05,443.73a16.64,16.64,0,0,1-3.49,3.52c-.87.71-1.76,1.44-2.69,2.09a11.5,11.5,0,0,1-5.72,2.33c-2.72.18-8.51-1.42-10.2-3.75a6.77,6.77,0,0,1-1-3.91,17.88,17.88,0,0,1,.94-5.46,30.42,30.42,0,0,1,4.41-8c2-2.74,4.16-5.43,7.09-7.09a27.35,27.35,0,0,1,3-1.39l5.33-2.18a2.5,2.5,0,0,1,1-.26c1.43,0,1.69,2.2.88,3.38-1.62,2.38-5.27,3-6.3,5.73a4.09,4.09,0,0,1,3.8,2.95,2.11,2.11,0,0,0,.51,1.19c.47.37,1.21.16,1.74.45.95.5.53,1.91.63,3a13.5,13.5,0,0,0,1,2.68A5.69,5.69,0,0,1,801.05,443.73Z",
  transform: "translate(-50 -46.63)",
  fill: "#ee8e9e"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  d: "M643.4,833.08c.88-.88,2.32-.73,3.55-.54a132,132,0,0,0,19.95,1.61c.84-4.08-1.59-8-2.37-12.14a10.76,10.76,0,0,0-.8-3.08c-.94-1.8-3.06-2.63-5.05-3-3.59-.76-9.21-2.09-11.22,1.54C645.05,821.78,644.28,828.22,643.4,833.08Z",
  transform: "translate(-50 -46.63)",
  fill: "#65617d"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M716.49,817.65c-2.71,1.85-6.07,2.42-9.33,2.84s-6.61.74-9.57,2.19c-2.54,1.26-4.69,3.32-7.39,4.22a15.31,15.31,0,0,1-7.67.12c-3-.57-6.26-1.67-7.89-4.29-1.46-2.32-1.31-5.27-1.11-8,.24-3.09.47-6.2.69-9.3a4.4,4.4,0,0,1,.58-2.24c2.19-3.2,7.52,1.33,10.37,1.33,4.52,0,9.37-2.46,12.62-5.45a3.89,3.89,0,0,1,1-.74c1.29-.58,2.58.49,3.72,1.42l.39.31c2.64,2.09,6.18,2.52,9.44,3.37s6.75,2.55,7.76,5.77a4.57,4.57,0,0,1,.16.61C720.83,812.76,719,815.91,716.49,817.65Z",
  transform: "translate(-50 -46.63)",
  fill: "#3f3d56"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  d: "M716.49,817.65c-2.71,1.85-6.07,2.42-9.33,2.84s-6.61.74-9.57,2.19c-2.54,1.26-4.69,3.32-7.39,4.22a15.31,15.31,0,0,1-7.67.12c-3-.57-6.26-1.67-7.89-4.29-1.46-2.32-1.31-5.27-1.11-8,.24-3.09.47-6.2.69-9.3a4.4,4.4,0,0,1,.58-2.24c2.19-3.2,7.52,1.33,10.37,1.33,4.52,0,9.37-2.46,12.62-5.45a3.89,3.89,0,0,1,1-.74c1.29-.58,2.58.49,3.72,1.42l.39.31c2.64,2.09,6.18,2.52,9.44,3.37s6.75,2.55,7.76,5.77a4.57,4.57,0,0,1,.16.61C720.83,812.76,719,815.91,716.49,817.65Z",
  transform: "translate(-50 -46.63)",
  fill: "#434175"
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  d: "M716.49,818.69c-2.71,1.85-6.07,2.43-9.33,2.85s-6.61.73-9.57,2.18c-2.54,1.26-4.69,3.32-7.39,4.22a15.31,15.31,0,0,1-7.67.12,12.6,12.6,0,0,1-7.89-5.33c-1.46-2.32-1.31-5.27-1.11-8,.24-3.09.47-6.2.69-9.3a4.4,4.4,0,0,1,.58-2.24c2.19-3.2,7.52,1.33,10.37,1.33,4.52,0,9.37-2.46,12.62-5.45a3.89,3.89,0,0,1,1-.74c1.29-.58,2.58.49,3.72,1.42a26.4,26.4,0,0,1-3.17,6.56,13.63,13.63,0,0,1-10,6.22c-2,.15-4.09-.25-6,.27s-3.77,2.52-3.08,4.42,3.06,2.25,5,2.36a22.38,22.38,0,0,0,8.21-.58c1.6-.53,3.07-1.41,4.62-2.06,6.62-2.74,15-1.21,20.46-5.85a13,13,0,0,1,1.67-1.28C721.67,812.8,719,817,716.49,818.69Z",
  transform: "translate(-50 -46.63)",
  fill: "#e8eaf2"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  d: "M716.49,818.69c-2.71,1.85-6.07,2.43-9.33,2.85s-6.61.73-9.57,2.18c-2.54,1.26-4.69,3.32-7.39,4.22a15.31,15.31,0,0,1-7.67.12,12.6,12.6,0,0,1-7.89-5.33c-1.46-2.32-1.31-5.27-1.11-8,.24-3.09.47-6.2.69-9.3a4.4,4.4,0,0,1,.58-2.24c2.19-3.2,7.52,1.33,10.37,1.33,4.52,0,9.37-2.46,12.62-5.45a3.89,3.89,0,0,1,1-.74c1.29-.58,2.58.49,3.72,1.42a26.4,26.4,0,0,1-3.17,6.56,13.63,13.63,0,0,1-10,6.22c-2,.15-4.09-.25-6,.27s-3.77,2.52-3.08,4.42,3.06,2.25,5,2.36a22.38,22.38,0,0,0,8.21-.58c1.6-.53,3.07-1.41,4.62-2.06,6.62-2.74,15-1.21,20.46-5.85a13,13,0,0,1,1.67-1.28C721.67,812.8,719,817,716.49,818.69Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.05
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  d: "M644.64,616.07a40.77,40.77,0,0,0,5.58,30c1.55,2.4,3.37,4.66,4.54,7.27a33.77,33.77,0,0,1,1.77,5.77l5,20.8c1.36,5.62,2.73,11.34,2.32,17.11-.28,4-1.3,8.53,1.18,11.71a8.46,8.46,0,0,1,1.49,2.05,5.15,5.15,0,0,1,0,2.7c-2.54,15.11-4.43,30.9.16,45.51,4.17,13.25,4.41,27.93,7.95,41.35a9.24,9.24,0,0,0,2.19,4.59,7.27,7.27,0,0,0,3.3,1.56c5.22,1.25,10.73-.21,15.59-2.46,3.42-1.59,7.1-4.37,6.81-8.12-.14-1.79-1.18-3.36-1.89-5-1.39-3.23-1.5-6.83-1.88-10.33-.94-8.78-3.65-17.26-5.69-25.84s-3.44-17.57-1.71-26.23a229.79,229.79,0,0,1,16.87-51.9,6.27,6.27,0,0,1,1.55-2.32,16.86,16.86,0,0,0,2.19-1.49,6.66,6.66,0,0,0,1-2.72c.76-2.74,3-4.77,4.53-7.17,3.83-6.08,2.62-13.87,2.48-21.05-.14-7,.86-14-.28-20.92S714.65,607,708,604.88c-3.29-1.07-6.85-.82-10.29-.48C679.48,606.2,661.76,609.51,644.64,616.07Z",
  transform: "translate(-50 -46.63)",
  fill: "#696791"
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  d: "M644.64,617.07a40.77,40.77,0,0,0,5.58,30c1.55,2.4,3.37,4.66,4.54,7.27a33.77,33.77,0,0,1,1.77,5.77l5,20.8c1.36,5.62,2.73,11.34,2.32,17.11-.28,4-1.3,8.53,1.18,11.71a8.46,8.46,0,0,1,1.49,2.05,5.15,5.15,0,0,1,0,2.7c-2.54,15.11-4.43,30.9.16,45.51,4.17,13.25,4.41,27.93,7.95,41.35a9.24,9.24,0,0,0,2.19,4.59,7.27,7.27,0,0,0,3.3,1.56c5.22,1.25,10.73-.21,15.59-2.46,3.42-1.59,7.1-4.37,6.81-8.12-.14-1.79-1.18-3.36-1.89-5-1.39-3.23-1.5-6.83-1.88-10.33-.94-8.78-3.65-17.26-5.69-25.84s-3.44-17.57-1.71-26.23a229.79,229.79,0,0,1,16.87-51.9,6.27,6.27,0,0,1,1.55-2.32,16.86,16.86,0,0,0,2.19-1.49,6.66,6.66,0,0,0,1-2.72c.76-2.74,3-4.77,4.53-7.17,3.83-6.08,2.62-13.87,2.48-21.05-.14-7,.86-14-.28-20.92S714.65,608,708,605.88c-3.29-1.07-6.85-.82-10.29-.48C679.48,607.2,661.76,610.51,644.64,617.07Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M718.92,659.86a44,44,0,0,1-.91,8.07q-4.83,27-10.28,54c-.32,1.56-.63,3.12-1.05,4.65a37.78,37.78,0,0,1-7,13.7c-15.15,18.89-16.46,46.32-24.68,69.1-.56,1.54-1.11,3.09-1.7,4.61a115.75,115.75,0,0,1-5.07,11.31,3.22,3.22,0,0,1-1,1.35,3.08,3.08,0,0,1-1.65.33,48.31,48.31,0,0,1-21.36-4.86,4.48,4.48,0,0,1-2.27-1.89,4.66,4.66,0,0,1-.24-2.17c.23-4.51.51-9.19,2.66-13.16a28.22,28.22,0,0,1,5.26-6.38,242.36,242.36,0,0,1,5.16-42.22c1.6-7.08,3.58-14.23,7.69-20.21,3-4.42,7.38-8.78,6.84-14.11-.23-2.34-1.21-5.25.69-6.62.83-.61,2.06-.69,2.63-1.55a3,3,0,0,0,.37-1.32,32.66,32.66,0,0,0-.68-10.93,58.79,58.79,0,0,1-1.63-7.13,9,9,0,0,1,1.79-6.88c.1-4.87,0-9.92.07-14.78a27.16,27.16,0,0,0-.69-8.25c-.36-1.27-.93-2.49-1.21-3.79-1-4.67,1.52-10.27-1.5-14-1.26-1.54-3.2-2.31-4.85-3.42a17.71,17.71,0,0,1-6.66-9.57A52.59,52.59,0,0,1,655.75,622a11.28,11.28,0,0,1,0-2.53,4.35,4.35,0,0,1,.34-1.27c.94-2.11,3.46-2.93,5.71-3.47a185.15,185.15,0,0,1,43.61-5.1c5.44-3.7,8.49-2.37,10.8,1.54a41.09,41.09,0,0,1,3.07,7.51c1,3.18,1.12,21,2.14,24.17C722.72,647,718.87,655.5,718.92,659.86Z",
  transform: "translate(-50 -46.63)",
  fill: "#696791"
});

var _ref84 =
/*#__PURE__*/
React.createElement("path", {
  d: "M620.68,497.92c-.4,2.8.94,5.55,1.09,8.38.13,2.47-.66,4.88-1.1,7.31-1.76,9.48,1.61,19.09,5,28.11a14.4,14.4,0,0,1,1.2,4.62c.09,2.94-1.6,5.64-2.07,8.55-1,6.11,3.53,11.85,3.63,18,0,2.85-.86,5.75-.14,8.5.47,1.84,1.62,3.43,2.43,5.14,1.45,3,1.84,6.5,3.22,9.57,2.49,5.55,7.84,9.18,12.94,12.51,2.89-1,6-2.11,7.62-4.72a11.63,11.63,0,0,0,1.33-4.14c1.1-6.33,1.06-12.79,1-19.21A118.59,118.59,0,0,0,656,564c-1-7-3.29-13.7-4.92-20.57-2-8.65-3.09-17.59-6.28-25.9-2.81-7.29-7.17-13.84-11.77-20.12-1.75-2.39-3.14-5.81-6.54-5.26A7.13,7.13,0,0,0,620.68,497.92Z",
  transform: "translate(-50 -46.63)",
  fill: "#434175"
});

var _ref85 =
/*#__PURE__*/
React.createElement("path", {
  d: "M620.68,495.92c-.4,2.8.94,5.55,1.09,8.38.13,2.47-.66,4.88-1.1,7.31-1.76,9.48,1.61,19.09,5,28.11a14.4,14.4,0,0,1,1.2,4.62c.09,2.94-1.6,5.64-2.07,8.55-1,6.11,3.53,11.85,3.63,18,0,2.85-.86,5.75-.14,8.5.47,1.84,1.62,3.43,2.43,5.14,1.45,3,1.84,6.5,3.22,9.57,2.49,5.55,7.84,9.18,12.94,12.51,2.89-1,6-2.11,7.62-4.72a11.63,11.63,0,0,0,1.33-4.14c1.1-6.33,1.06-12.79,1-19.21A118.59,118.59,0,0,0,656,562c-1-7-3.29-13.7-4.92-20.57-2-8.65-3.09-17.59-6.28-25.9-2.81-7.29-7.17-13.84-11.77-20.12-1.75-2.39-3.14-5.81-6.54-5.26A7.13,7.13,0,0,0,620.68,495.92Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.05
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  d: "M694.66,436.91a59.69,59.69,0,0,0-5.55,11.43,26.19,26.19,0,0,1-6.3.76c-8.25,0-14.08-4.69-18.93-10.62-.42-1.9-3-3.67-2.74-5.16.39-2,2.25-1.59,3.93-1.48a150.51,150.51,0,0,1,15.26,2C681.65,434,694.46,437.24,694.66,436.91Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref87 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 632.81,
  cy: 375.34,
  r: 26.41,
  fill: "#ee8e9e"
});

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  d: "M716.18,611.19c-4.57-.27-9.18-.08-13.76.1a47.15,47.15,0,0,0-8.55.88c-3.47.79-6.71,2.37-10.13,3.36-5.48,1.59-11.26,1.66-16.93,2.22a94.36,94.36,0,0,0-11.09,1.74,4.35,4.35,0,0,1,.34-1.27c.94-2.11,3.46-2.93,5.71-3.47a185.15,185.15,0,0,1,43.61-5.1C710.82,606,713.87,607.28,716.18,611.19Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M698.18,465.21c-1.15,1.33-2.7,2.8-4.4,2.37a6.08,6.08,0,0,1-1.72-.92c-3-2-6.78-2.42-10.36-3a152.4,152.4,0,0,1-21.34-4.8,21.93,21.93,0,0,0-6.32-1.28c-4.47,0-8.44,3-11.24,6.48s-4.8,7.57-7.55,11.1c-2,2.52-4.3,4.74-6.13,7.35-4.62,6.59-5.62,15.19-4.42,23.15s4.37,15.47,7.53,22.88A78.47,78.47,0,0,0,638.37,541c-1.06,6-.5,13,2.38,18.4.93,1.77,2.08,3.49,2.39,5.47a13.85,13.85,0,0,1-.16,4l-1.35,9.56c-.41,2.91-.82,5.82-1.35,8.72-1,5.29-2.28,11,.17,15.82,2.93,5.74-.15,13.09.62,19.49a97.8,97.8,0,0,1,25.74-6.11c5.67-.56,11.45-.63,16.93-2.22,3.42-1,6.66-2.57,10.13-3.37a47,47,0,0,1,8.55-.87c6.33-.25,12.7-.51,19,.42.5.08,1.12.12,1.43-.29a1.47,1.47,0,0,0,.19-.75,12.63,12.63,0,0,0-1.62-6.72c-.8-1.41-1.91-2.79-1.88-4.41a6.48,6.48,0,0,1,.55-2.19l2.77-7.4c2.35-6.25,1.23-13.51,2.45-20.07a117.46,117.46,0,0,0,1.82-15.53c.23-4.45.09-9.27-2.6-12.83a14.67,14.67,0,0,1-2-2.83,8.34,8.34,0,0,1-.48-3.37q-.09-13.36.73-26.72c-2.34-4.21-4.79-8.51-7.13-12.72-2.73-4.9-5.49-9.9-6.59-15.4-.73-3.63-.71-7.38-1.23-11.05a4.9,4.9,0,0,0-.93-2.59,4.69,4.69,0,0,0-3.76-1.11A16.44,16.44,0,0,0,698.18,465.21Z",
  transform: "translate(-50 -46.63)",
  fill: "#434175"
});

var _ref90 =
/*#__PURE__*/
React.createElement("path", {
  d: "M794.87,449.34a11.5,11.5,0,0,1-5.72,2.33c-2.72.18-8.51-1.42-10.2-3.75a6.77,6.77,0,0,1-1-3.91,4.91,4.91,0,0,1,1.14-.22,29.88,29.88,0,0,1,8.86.36c2.88.7,5.66,2.45,6.87,5.16Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref91 =
/*#__PURE__*/
React.createElement("path", {
  d: "M707,506.46c1.61,2,3.28,4.06,5.56,5.25,2.63,1.36,5.72,1.39,8.67,1.33a208,208,0,0,0,36.23-4,22.81,22.81,0,0,0,4-1.07,20.6,20.6,0,0,0,4-2.52c3.93-2.82,7.92-5.7,10.91-9.51a32.05,32.05,0,0,0,6.46-15.85c2.84-2.61,4.35-6.34,5.77-9.93a15.24,15.24,0,0,0,1.32-4.82c.07-1.71-1.06-3.5-.74-5.18a13.64,13.64,0,0,1,4.19-7.54,2.74,2.74,0,0,0,1-1.33,2.1,2.1,0,0,0-.23-1.29c-1.22-2.71-4-4.45-6.88-5.16a29.61,29.61,0,0,0-8.87-.36,20.06,20.06,0,0,0-2.9.78l-2.07,5.43a6.88,6.88,0,0,1-1.35,2.48,12.52,12.52,0,0,1-1.46,1.15,8.38,8.38,0,0,0-2.91,7.33,7.88,7.88,0,0,0-4.66,9.72,9.3,9.3,0,0,0-6.81,6,4.45,4.45,0,0,1-.89,1.87A3.66,3.66,0,0,1,753,480c-2.34.14-4.38,2-6.49,1a13.29,13.29,0,0,0-7.71-1.08,5.77,5.77,0,0,1-1.65.15,4.43,4.43,0,0,1-1.35-.47,10.72,10.72,0,0,0-3.06-1.2,2.84,2.84,0,0,0-2.9,1.12c-.74-.81-1.18-1.85-1.85-2.72a3,3,0,0,0-2.82-1.35c.7-.62,0-1.87-.93-2.1a12.66,12.66,0,0,0-2.81.1c-2.44,0-4.32-2.23-6.69-2.81-2.18-.53-5.09.11-6.21-1.84-.39-.69-.47-1.63-1.14-2a2.2,2.2,0,0,0-1.48-.17,14.24,14.24,0,0,0-4.45,1.35c-2.29,9-1.09,18.24.65,27.3A24.07,24.07,0,0,0,707,506.46Z",
  transform: "translate(-50 -46.63)",
  fill: "#434175"
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  d: "M706.93,538.51l-11.37,22.94c1.23-2.13,3.82-3,5.87-4.31A15.54,15.54,0,0,0,707,549.6a47.14,47.14,0,0,0,2.15-9.29c.23-1.45.71-3.49,0-4.81C707.89,535.77,707.47,537.44,706.93,538.51Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref93 =
/*#__PURE__*/
React.createElement("path", {
  d: "M674.21,558c-2.57,2.54-5.71,4.41-8.53,6.66-6.6,5.26-11.3,12.46-15.89,19.53a30.77,30.77,0,0,0-3.25,5.92c.54.46,1.34,0,1.88-.49l8.93-7.84a20.19,20.19,0,0,0,3-3c1.55-2.09,2.24-4.69,3.65-6.88a26.84,26.84,0,0,1,5.43-5.53c2.05-1.76,11.47-9.73,9.18-12.83C676.92,554.34,675.56,556.64,674.21,558Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref94 =
/*#__PURE__*/
React.createElement("path", {
  d: "M693.72,458.58a26.78,26.78,0,0,0-9.45-3.11,20,20,0,0,0-6-.43c-1.86.23-3.65.95-5.52,1-2.63.15-5.14-.92-7.68-1.61s-5.47-1-7.6.57a3.29,3.29,0,0,1-1.66.88,3,3,0,0,1-1.71-.84,9.74,9.74,0,0,0-12.14.64c-4.84,4.54-4.29,13.41-10,16.86-1.56,1-3.56,1.45-4.48,3a12,12,0,0,1-.77,1.46,4,4,0,0,1-1.36,1,26.43,26.43,0,0,0-4.68,2.69,6.66,6.66,0,0,0-2.69,4.51,8.53,8.53,0,0,0,.82,3.79,35.62,35.62,0,0,0,34.61,22.13,5.42,5.42,0,0,0,3.63-1.13,6.93,6.93,0,0,0,1.27-2.09c2.67-5.59,7.68-9.72,10.86-15,1.89-3.17,3.11-6.72,5.09-9.84,3-4.73,7.54-8.23,12-11.62,2.52-1.91,5.31-3.92,8.47-3.79,2.81.12,4.86.27,3.82-3.17A11,11,0,0,0,693.72,458.58Z",
  transform: "translate(-50 -46.63)",
  fill: "#434175"
});

var _ref95 =
/*#__PURE__*/
React.createElement("path", {
  d: "M693.72,458.58a26.78,26.78,0,0,0-9.45-3.11,20,20,0,0,0-6-.43c-1.86.23-3.65.95-5.52,1-2.63.15-5.14-.92-7.68-1.61s-5.47-1-7.6.57a3.29,3.29,0,0,1-1.66.88,3,3,0,0,1-1.71-.84,9.74,9.74,0,0,0-12.14.64c-4.84,4.54-4.29,13.41-10,16.86-1.56,1-3.56,1.45-4.48,3a12,12,0,0,1-.77,1.46,4,4,0,0,1-1.36,1,26.43,26.43,0,0,0-4.68,2.69,6.66,6.66,0,0,0-2.69,4.51,8.53,8.53,0,0,0,.82,3.79,35.62,35.62,0,0,0,34.61,22.13,5.42,5.42,0,0,0,3.63-1.13,6.93,6.93,0,0,0,1.27-2.09c2.67-5.59,7.68-9.72,10.86-15,1.89-3.17,3.11-6.72,5.09-9.84,3-4.73,7.54-8.23,12-11.62,2.52-1.91,5.31-3.92,8.47-3.79,2.81.12,4.86.27,3.82-3.17A11,11,0,0,0,693.72,458.58Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.05
});

var _ref96 =
/*#__PURE__*/
React.createElement("path", {
  d: "M707.47,841.36c-1.92,1.79-4.55,2.57-7.1,3.12a127.7,127.7,0,0,1-17.67,2.19l-5.77.44c-5.63.43-11.27.86-16.92.88a117.17,117.17,0,0,1-20.82-1.8,2.28,2.28,0,0,1-1.65-.8,2.24,2.24,0,0,1-.25-1.31,100.74,100.74,0,0,1,2.56-20.9c.65-2.81,5.7,3.5,5.93,3.77a5.76,5.76,0,0,0,4.59,2.43c5.81.32,12.32-3.21,16.93-6.35a22.18,22.18,0,0,1,3.14-1.95,9.19,9.19,0,0,1,2.54-.72,15.28,15.28,0,0,1,8.64,1.75c3.47,1.72,6.51,4.19,10,6a28.06,28.06,0,0,0,8.92,2.82c3.14.43,6.9.64,8.51,3.36v0C710.33,836.54,709.37,839.58,707.47,841.36Z",
  transform: "translate(-50 -46.63)",
  fill: "#434175"
});

var _ref97 =
/*#__PURE__*/
React.createElement("path", {
  d: "M707.47,842.4c-1.92,1.79-4.55,2.57-7.1,3.12a127.7,127.7,0,0,1-17.67,2.19l-5.77.44c-5.63.43-11.27.86-16.92.88a116.24,116.24,0,0,1-20.82-1.8,2.27,2.27,0,0,1-1.65-.79,9.26,9.26,0,0,1-1.29-2.36c.12-7,2-14.05,3.6-20.9.65-2.81,5.7,3.5,5.93,3.77a5.76,5.76,0,0,0,4.59,2.43c5.81.32,12.32-3.21,16.93-6.35a22.18,22.18,0,0,1,3.14-1.95,9.19,9.19,0,0,1,2.54-.72c-.75,4.18-6.74,9.23-9.84,10.77-6.26,3.11-13.7,1.55-20.68,1.92a3,3,0,0,0-1.47.35c-.83.56-.88,1.75-.86,2.75.06,1.66.27,3.62,1.72,4.46a4.94,4.94,0,0,0,2.32.49,327.89,327.89,0,0,0,51.57-1.81,28.23,28.23,0,0,0,8.4-1.87,21.44,21.44,0,0,0,4.87-3.14C711.21,836,709.37,840.62,707.47,842.4Z",
  transform: "translate(-50 -46.63)",
  fill: "#e8eaf2"
});

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  d: "M693.09,421.69c-.1,2.73,1.76,8-3.35,6.55-3-.88-3.9-4.49-7.76-3.69s-4.76,5.57-6.06,8.68a16.59,16.59,0,0,1-12,9.72,7.26,7.26,0,0,1-3.31,0c-2.49-.71-3.91-3.28-4.93-5.66a44.08,44.08,0,0,1-2.18-6.22,25.31,25.31,0,0,1-.79-4.56h0a19.48,19.48,0,0,1,0-3.15c.46-6.21,4-11.87,8.52-16.15s10-7.38,15.45-10.43a22.9,22.9,0,0,1,5.7-2.54,19.21,19.21,0,0,1,6-.24,20.85,20.85,0,0,1,7.66,1.8,10.71,10.71,0,0,1,2.69,1.89,8.11,8.11,0,0,1,2.34,3.89c1,4-1.58,7.63-3.66,10.8C695.51,415.19,693.22,418.17,693.09,421.69Z",
  transform: "translate(-50 -46.63)",
  fill: "#434175"
});

var _ref99 =
/*#__PURE__*/
React.createElement("path", {
  d: "M779,480.3c-1.09-2.75-5.67-10.36-4.35-13a33.77,33.77,0,0,1,3.49,6.24C779,475.69,778.32,478.55,779,480.3Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref100 =
/*#__PURE__*/
React.createElement("path", {
  d: "M697.47,412.37c2.08-3.17,4.64-6.79,3.66-10.8a8.35,8.35,0,0,0-3-4.44,7.27,7.27,0,0,1,.76,1.87c1,4-1.58,7.62-3.66,10.8-1.85,2.82-4.14,5.81-4.28,9.32-.1,2.73,1.77,8-3.34,6.55-3-.88-3.9-4.49-7.77-3.69s-4.75,5.56-6.06,8.68a16.57,16.57,0,0,1-12,9.72,7.26,7.26,0,0,1-3.31,0,5.05,5.05,0,0,1-1.56-.77,6.76,6.76,0,0,0,3.77,3.34,7.44,7.44,0,0,0,3.32,0,16.63,16.63,0,0,0,12-9.73c1.31-3.12,2.16-7.86,6.06-8.67s4.72,2.8,7.77,3.68c5.11,1.48,3.24-3.82,3.34-6.55C693.33,418.18,695.63,415.19,697.47,412.37Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref101 =
/*#__PURE__*/
React.createElement("path", {
  d: "M698.6,406.94a21.84,21.84,0,0,1-1.56,2.24,26.58,26.58,0,0,1-3.61,3.74c-.79.68-1.6,1.31-2.44,1.91a38.47,38.47,0,0,1-4.93,2.95,91.47,91.47,0,0,1-15.78,5.65l-10.54,3.07c-1.3,1-3.67,2.74-6.28,4.57a25.31,25.31,0,0,1-.79-4.56h0a19.48,19.48,0,0,1,0-3.15c.46-6.21,4-11.87,8.52-16.15s10-7.38,15.45-10.43a22.9,22.9,0,0,1,5.7-2.54,19.21,19.21,0,0,1,6-.24,20.85,20.85,0,0,1,7.66,1.8,10.71,10.71,0,0,1,2.69,1.89,10.14,10.14,0,0,1,1.35,2.86C700.7,402.7,699.78,405,698.6,406.94Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref102 =
/*#__PURE__*/
React.createElement("path", {
  d: "M698.6,406.23a21.84,21.84,0,0,1-1.56,2.24,26.58,26.58,0,0,1-3.61,3.74c-.79.68-1.6,1.31-2.44,1.91a39.65,39.65,0,0,1-4.93,2.95,91.47,91.47,0,0,1-15.78,5.65l-10.54,3.06c-3.68,2.79-16,11.91-18.07,10.77-2.44-1.34,10.93-10.81,10.93-10.81l.61.47c-2-1.23-3-4.08-3.42-6.55-.78-4.42-1.15-9-.1-13.37s3.67-8.51,7.66-10.55c1.77-.92,3.92-1.53,5.2-2.93a4.4,4.4,0,0,0,.51-.69,2.08,2.08,0,0,0,.2-.36,4.32,4.32,0,0,1,.56-1.09c.73-.84,2.06-.59,3.17-.45l.36,0a5.68,5.68,0,0,0,.59,0c4,.09,7.81-2.12,11.82-2.12,4.39,0,8.13,2.54,12,4.28.78.35,1.52.67,2.22,1,2.8,1.3,4.9,2.69,6,6.38C700.7,402,699.78,404.31,698.6,406.23Z",
  transform: "translate(-50 -46.63)",
  fill: "#6c63ff"
});

var _ref103 =
/*#__PURE__*/
React.createElement("path", {
  d: "M667.94,390.28a1.8,1.8,0,0,1-.42,2.32,3.2,3.2,0,0,1-1.66.59,11.2,11.2,0,0,1-1.3.1,3.58,3.58,0,0,1-1.71-.29,2.2,2.2,0,0,1-.3-.19,4.4,4.4,0,0,0,.51-.69c.1.08.2.06.59,0a9.13,9.13,0,0,0,2.14-.36,2.38,2.38,0,0,0,.8-.39,2.48,2.48,0,0,0,.76-1.15Z",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var _ref104 =
/*#__PURE__*/
React.createElement("path", {
  d: "M652.86,425.64a4.87,4.87,0,0,0,1.83.68,8.29,8.29,0,0,0,1.41.23,7.84,7.84,0,0,0,3.45-1",
  transform: "translate(-50 -46.63)",
  opacity: 0.1
});

var SvgUndrawOperatingSystem4Lr6 = function SvgUndrawOperatingSystem4Lr6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "a91a722e-5259-4ef2-8c31-2e8a1147b313",
    "data-name": "Layer 1",
    width: 1100,
    height: 806.74,
    viewBox: "0 0 1100 806.74",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawOperatingSystem4Lr6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_operating_system_4lr6.e0cfb20c.svg";
export { ForwardRef as ReactComponent };